<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>{{registData.retMsg}}</span>
                </div>
            </div>
          <div @click="closeRegistrationPopup">
            <bottom-button :buttonArray="buttonArray"></bottom-button>
          </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'StopUsingPopupCancel',
    components: {BottomButton},
    data() {
        return  {
            buttonArray : [
                {
                    className : "button-bg-gray",
                    text : "닫기",
                },
            ],
            barcodeNumber: false,
        }
    },
    props: {
      registData : Object,
    },
    methods : {
        closeRegistrationPopup(){
          this.$emit('closePopup');
        }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsingCancelPopup.scss';
</style>